import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { GuestLiteModel } from 'api-hooks/guest';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getCustomersInput,
  getCustomerInput,
  CustomerLiteModel,
  CustomerModel,
  getCustomerGuestsInput,
} from './model';

export function useGetCustomers(
  input?: getCustomersInput,
  options?: UseQueryOptions<ExtendedApiResult<CustomerLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<CustomerLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getCustomers', input?.params],
      () =>
        QueryFetchFunction({
          url: 'customers',
          params: input?.params,
        }),
      options,
    ),
    CustomerLiteModel,
  );
}

export function useGetCustomer(
  input?: getCustomerInput,
  options?: UseQueryOptions<ApiResult<CustomerModel>, ApiError>,
): UseQueryResult<ApiResult<CustomerModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getCustomer', input?.id],
      () => QueryFetchFunction({ url: `customers/${input?.id}` }),
      options,
    ),
    CustomerModel,
  );
}

export function useGetCustomerGuests(
  input?: getCustomerGuestsInput,
  options?: UseQueryOptions<ExtendedApiResult<GuestLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<GuestLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getCustomerGuests', input],
      () =>
        QueryFetchFunction({
          url: `customers/${input?.id}/guests`,
          params: input?.params,
        }),
      options,
    ),
    GuestLiteModel,
  );
}

export function getCustomersKey(input?: getCustomersInput) {
  return ['getCustomers', input?.params];
}

export function getCustomerKey(input?: getCustomerInput) {
  return ['getCustomer', input?.id];
}

export function getCustomerGuestKey(input?: getCustomerGuestsInput) {
  return ['getCustomerGuests', input];
}
